import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"
import * as am5 from "@amcharts/amcharts5"
import * as am5xy from "@amcharts/amcharts5/xy"
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import {useEffect} from "react"
import {SpinnerGrid} from "../../shared/CommonItems"

export const ProfitOrLossChart = () => {
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const profitorlossmonthlyDetail = useAppSelector(
        (state: RootState) => state.containers.dashboard.profitorlossmonthlyDetail,
    )
    const isLoadingProfitLossPer = useAppSelector(
        (state: RootState) => state.containers.dashboard.isLoadingProfitLossPer,
    )
    useEffect(() => {
        if (selectedDealer && profitorlossmonthlyDetail) {
            MonthlyProfitLossChart(profitorlossmonthlyDetail)
        }
    }, [profitorlossmonthlyDetail, selectedDealer])

    const maybeDisposeRoot = (divId: string) => {
        am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom != null && root.dom.id === divId) {
                root.dispose()
            }
        })
    }

    const MonthlyProfitLossChart = (chartdata: any) => {
        maybeDisposeRoot("profitOrLossChart")
        const root = am5.Root.new("profitOrLossChart")

        root.setThemes([am5themes_Animated.new(root)])

        am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            filePrefix: "ProfitOrLoss",
        })
        const chart: any = root.container.children.push(am5xy.XYChart.new(root, {}))

        const yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                extraTooltipPrecision: 1,
                renderer: am5xy.AxisRendererY.new(root, {
                    minGridDistance: 30,
                }),
            }),
        )

        const xAxis = chart.xAxes.push(
            am5xy.DateAxis.new(root, {
                baseInterval: {timeUnit: "month", count: 1},
                renderer: am5xy.AxisRendererX.new(root, {
                    minGridDistance: 20,
                    cellStartLocation: 0.2,
                    cellEndLocation: 0.8,
                }),
            }),
        )

        const profitOrLossSeries = chart.series.push(
            am5xy.LineSeries.new(root, {
                xAxis,
                yAxis,
                valueYField: "visits",
                valueXField: "date",
                fill: am5.color(0x01b8aa),
                tooltip: am5.Tooltip.new(root, {
                    labelText: `{valueX.formatDate('MMM, YYYY')} {valueY}`,
                    pointerOrientation: "horizontal",
                }),
            }),
        )

        profitOrLossSeries.strokes.template.setAll({
            stroke: am5.color(0x01b8aa),
            strokeWidth: 1,
        })

        profitOrLossSeries.fills.template.setAll({
            fillOpacity: 0.8,
            visible: true,
        })

        profitOrLossSeries.data.setAll(chartdata)

        const rangeDataItem = yAxis.makeDataItem({
            value: -100000,
            endValue: 0,
        })

        const range: any = profitOrLossSeries.createAxisRange(rangeDataItem)

        range.strokes.template.setAll({
            stroke: am5.color(0xfd625e),
            strokeWidth: 1,
        })

        range.fills.template.setAll({
            fill: am5.color(0xfd625e),
            fillOpacity: 0.8,
            visible: true,
        })

        rangeDataItem.get("axisFill").setAll({
            fill: am5.color(0xfd625e),
            fillOpacity: 0.05,
            visible: true,
        })

        profitOrLossSeries.on("tooltipDataItem", function (tooltipDataItem: any) {
            if (tooltipDataItem) {
                const value = tooltipDataItem.get("valueY")
                let fill = profitOrLossSeries.get("fill")
                profitOrLossSeries.axisRanges.each(function (axisRange: any) {
                    const axisDataItem = axisRange.axisDataItem
                    if (value >= axisDataItem.get("value") && value < axisDataItem.get("endValue")) {
                        fill = axisDataItem.get("axisFill").get("fill")
                    }
                })
                profitOrLossSeries.getTooltip().get("background").set("fill", fill)
                xAxis.getTooltip().get("background").set("fill", fill)
            }
        })
        profitOrLossSeries.get("tooltip").set("getFillFromSprite", false)
        chart.set("cursor", am5xy.XYCursor.new(root, {}))

        xAxis.set(
            "tooltip",
            am5.Tooltip.new(root, {
                themeTags: ["axis"],
            }),
        )

        yAxis.set(
            "tooltip",
            am5.Tooltip.new(root, {
                themeTags: ["axis"],
            }),
        )
    }

    return (
        <>
            {isLoadingProfitLossPer && <SpinnerGrid />}
            <div className="h-100" id="profitOrLossChart"></div>
        </>
    )
}
